import React, { Component } from 'react';
import styled, {ThemeProvider, createGlobalStyle} from 'styled-components/macro';
import ExportModal from './ExportModal';
import Header from './Header';
import Menu from './Menu';
import Artboard from './Artboard';
import DEFAULT_OBJECTS from '../defaultObjects';

const StyledApp = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`


const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({theme}) => theme.bg};
  }
`

const theme = {
  black: {
    name: 'black',
    bg: '#000000',
    bg90: 'rgba(0,0,0,0.9)',
    bg00: 'rgba(0,0,0,0)',
    color: '#ffffff',
    color90: 'rgba(255,255,255,0.9)',
    grid: 'linear-gradient(#212121 1px, transparent 1px), linear-gradient(90deg, #212121 1px, transparent 1px)',
  },
  white: {
    name: 'white',
    bg: '#ffffff',
    bg90: 'rgba(255,255,255,0.9)',
    bg00: 'rgba(255,255,255,0)',
    color: '#000000',
    color90: 'rgba(0,0,0,0.9)',
    grid: 'linear-gradient(#cecece 1px, transparent 1px), linear-gradient(90deg, #cecece 1px, transparent 1px)',
  }
}

class App extends Component {

  constructor(props){


    super(props);
    this.state = {
      objects: DEFAULT_OBJECTS,
      activeObject: null,
      theme: theme.white,
      ruler: false,
      exportModal: false
    }
    this.setActiveObject = this.setActiveObject.bind(this);
    this.updateObjectSize = this.updateObjectSize.bind(this);
    this.updateObjectPosition = this.updateObjectPosition.bind(this);
    this.toogleColor = this.toogleColor.bind(this);
    this.toggleExportModal = this.toggleExportModal.bind(this);
    this.toggleRuler = this.toggleRuler.bind(this);

  }

  setActiveObject(id){
    this.setState({activeObject: id});
  }

  updateObjectSize(index, width, height){
    this.setState(state => {
      return {
        objects: [
          ...state.objects.slice(0,index),
		      {
            ...state.objects[index],
		        size: {width, height}
          },
		      ...state.objects.slice(index + 1)
        ]
      };
    });
  }

  updateObjectPosition(index, x, y){
    this.setState(state => {
      return {
        objects: [
          ...state.objects.slice(0,index),
		      {
            ...state.objects[index],
		        position: {x, y}
          },
		      ...state.objects.slice(index + 1)
        ]
      };
    });
  }

  toogleColor(color){
    if(color === 'black'){
      this.setState({theme: theme.black})
    }
    if(color === 'white'){
      this.setState({theme: theme.white})
    }
  }

  toggleExportModal(){
    this.setActiveObject(null);
    this.setState(prevState => ({
      exportModal: !prevState.exportModal
    }));
  }

  toggleRuler(){
    this.setState(prevState => ({
      ruler: !prevState.ruler
    }));
  }

  render() {
    let {objects, activeObject, theme, ruler, exportModal,} = this.state;
    return (
      <ThemeProvider theme={theme}>
        <StyledApp>
          <GlobalStyle/>
          <Header />
          <Menu
            ruler={ruler}
            activeObject={activeObject}
            action={{
              setActive: this.setActiveObject,
              toogleColor: this.toogleColor,
              toggleExportModal: this.toggleExportModal,
              toggleRuler: this.toggleRuler
            }}
          />
          <Artboard
            ruler={ruler}
            objects={objects}
            activeObject={activeObject}
            action={{
              setActive: this.setActiveObject,
              updateSize: this.updateObjectSize,
              updatePosition: this.updateObjectPosition
            }}
          />
          <ExportModal
            open={exportModal}
            closeModal={this.toggleExportModal}
            objects={objects}
          />
        </StyledApp>
      </ThemeProvider>
    );
  }
}

export default App;
